/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import sortTags from 'flarum/tags/common/utils/sortTags';
import LinkButton from 'flarum/common/components/LinkButton';
import Stream from 'flarum/common/utils/Stream';
import type Mithril from 'mithril';
import type Tag from 'flarum/tags/common/models/Tag';

export default class HomeCategories extends Component<Record<string, never>> {
	loading?: boolean;
	categories!: Tag[];
	showAll!: Stream<boolean>;

	oninit(vnode: Mithril.Vnode<Record<string, never>, this>) {
		super.oninit(vnode);

		this.categories = sortTags(app.store.all<Tag>('tags').filter((tag) => !tag.parent()));

		this.showAll = Stream(false);
	}

	view() {
		const categories = this.showAll() ? this.categories : this.categories.slice(0, 6);

		return (
			<div className="HomeCategories">
				<span className="BCQuote closing" />
				<h2>
					{this.titleText} {this.loading && <LoadingIndicator />}
				</h2>
				<div className="Home-subtitle">{this.subTitleText}</div>

				<ul className="HomeCategories-categories">{categories.map(this.listItem)}</ul>

				{!this.showAll() && this.categories.length > 6 && (
					<Button className="Button Button--large" onclick={() => this.showAll(true)}>
						{app.translator.trans('glowingblue-orell-thalia-common.forum.home.categories.more_label')}
					</Button>
				)}
			</div>
		);
	}

	get titleText(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-thalia-common.forum.home.categories.title');
	}
	get subTitleText(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-thalia-common.forum.home.categories.sub_title');
	}

	listItem(category: Tag) {
		return (
			<li key={category.id()} data-id={category.id()}>
				<LinkButton href={app.route.tag(category)} icon="far fa-chevron-right" className="LinkButton">
					{category.name()}
				</LinkButton>
			</li>
		);
	}
}
